import React, { useContext, useEffect, useState } from 'react'
import { Box, Checkbox, IconButton, TableBody, TableCell } from '@material-ui/core'
import Layout from '../components/Layout'
import CustomTable from '../components/Table/CustomTable'
import CustomTableHeading from '../components/Table/CustomTableHeading'
import CustomTableRow from '../components/Table/CustomTableRow'
import { useFeatures } from '../hooks/Features/useFeatures'
import { HiOutlineInformationCircle } from 'react-icons/hi'
import Loader from '../components/Loader'
import { itemsPerPage } from '../shared/data'
// import Moment from 'moment'
import moment from 'moment'
import CustomPagination from '../components/CustomPagination'
import CustomHeading from '../components/CustomHeading'
import { AiFillCheckCircle, AiOutlineCheckCircle } from 'react-icons/ai'
import { MdCancel } from 'react-icons/md'
import { GiCancel } from 'react-icons/gi'
import OverviewDialog from '../components/Dialog/OverviewDialog'
import ApproveDialog from '../components/Dialog/ApproveDialog'
import CustomLabel from '../components/CustomLabel'
import DashLayout from '../components/version-4/LeaveRequests'
import { SortIcon, FilterIcon } from '../components/CustomComponents/CustomFilterIcon'

import User from '../components/User'
import { handleSelectAllClick, handleSelectedItem, isSelected, paginatedData, paginatePages } from '../shared/constants'
import ConfirmDialog from '../components/Dialog/ConfirmDialog'
import { useLeave } from '../hooks/Features/useLeaves'
import { FeatureContext } from '../context api/Features/FeatureContext'
import { NoDataFound } from '../components/NoDataFound'
import { useDashBoard } from '../hooks/DashBoard/useDashBoard'
import { ConfigurationContext } from '../context api/Configuration/ConfigurationContext'
import { usePosition } from '../hooks/CompanyConfiguration/usePosition'
import CustomFilterModal from '../components/FilterArray/FilterArray'
import { UserContext } from '../context api/UserContext'
import Status from '../components/Status'

export default function AllLeaveRequests() {
  const { getBelowEmployeeLeaves, editLeaveRequest, BulkUpload, deleteLeave, deleteManyLeave, leaveThisWeek, monthLeave, loading, paginate, getPdfCsvData, pdfCsvData, downloadLoading } = useLeave()

  const { loading: dashLoading, leaveDashBoard, getLeaveDashBoard } = useDashBoard()
  const { leaves } = useContext(FeatureContext)
  const [selectedDate, setSelectedDate] = React.useState(new Date().toISOString())
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = React.useState(startDate.toISOString())
  const [to, setTo] = React.useState(new Date().toISOString())
  const user = useContext(UserContext)
  const companyAdmin = user && user.user && user.user.userType === 'COMPANYADMIN'
  const [leave, setLeave] = React.useState('')
  const [adminReason, setAdminReason] = React.useState('')
  const [approveDialog, setApproveDialog] = React.useState(false)
  const [rejectDialog, setRejectDialog] = React.useState(false)

  const handleApproveClose = () => {
    setApproveDialog(false)
    setAdminReason('')
  }
  const handleRejectClose = () => {
    setRejectDialog(false)
    setAdminReason('')
  }
  const [searchQuery, setSearchQuery] = React.useState('')

  const [selected, setSelected] = React.useState([])
  const [filterParams, setFilterParams] = useState({ page: 1 })
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const [GridAttend, setGridAttend] = React.useState(true)
  const [TableAttend, setTableAttend] = React.useState(false)

  const [openFilterModal, setOpenFilterModal] = React.useState(false)
  const [modalOpen, setModalOpen] = React.useState(false)
  const { getAllPosition } = usePosition()
  const { positions } = useContext(ConfigurationContext)

  // const { } = useLeave()
  const [uploadedfile, setUploadedFile] = React.useState('')

  const handleChange = (event, value) => {
    setFilterParams({
      ...filterParams,
      page: value,
    })
  }

  useEffect(() => {
    if (GridAttend) getLeaveDashBoard({ from, to })
    getBelowEmployeeLeaves({ ...filterParams, from, to, searchQuery })
  }, [filterParams, searchQuery, from, to])

  useEffect(() => {
    getAllPosition()
  }, [])

  useEffect(() => {
    getPdfCsvData({ from, to })
  }, [from, to])

  const fetchStatus = (type) => {
    switch (type) {
      case 'APPROVED':
        return <Status status="Accepted" />
      case 'REJECTED':
        return <Status status="Rejected" />
      default:
        return companyAdmin ? (
          <Box display="flex" justifyContent="space-evenly">
            <AiOutlineCheckCircle style={{ color: 'green', fontSize: '20px', cursor: 'pointer' }} onClick={() => setApproveDialog(true)} />
            <GiCancel style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }} onClick={() => setRejectDialog(true)} />
          </Box>
        ) : (
          <Status status="Pending" />
        )
    }
  }

  const calculateTotalDays = (from, to) => {
    const date1 = new Date(to)
    const date2 = new Date(from)
    const diffTime = Math.abs(date2 - date1)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    return diffDays + 1
  }

  const formatDate = (date) => {
    return moment(date).format('Do MMMM YYYY')
  }

  const noOfPages = paginate && paginate.totalPage

  const approveLeaveRequest = async (approved) => {
    editLeaveRequest(
      {
        leaveId: leave._id,
        leaveStatus: approved,
        from: leave.leaveFrom,
        to: leave.leaveTo,
        subType: leave.subType,
        adminReason: adminReason,
      },
      () => getLeaveDashBoard({ from, to })
    )
    if (approveDialog) {
      handleApproveClose()
    }
    if (rejectDialog) {
      handleRejectClose()
    }
  }

  const handleGrid = () => {
    setGridAttend(true)
    setTableAttend(false)
  }
  const handleTable = () => {
    setGridAttend(false)
    setTableAttend(true)
  }

  const bulkUpload = () => {
    const formData = new FormData()
    formData.append('file', uploadedfile)
    formData.append('sheetName', 'leaves')
    BulkUpload(formData)
    // setOpenPopup(false)
    setUploadedFile('')
  }

  const headingOnClick = {
    POSITION: () => {
      setModalOpen('position')
      setOpenFilterModal(true)
    },
  }

  return (
    <Layout
      heading="Leave Requests"
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleGrid={handleGrid}
      handleTable={handleTable}
      GridAttend={GridAttend}
      TableAttend={TableAttend}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      headers={pdfCsvData.headings}
      data={pdfCsvData.headingValues}
      bulkUpload={bulkUpload}
      uploadedfile={uploadedfile}
      setUploadedFile={setUploadedFile}
      selectedDate={selectedDate}
      // setSelectedDate={!GridAttend && setSelectedDate}
      editUrl={`/edit-leaveRequest/${selected.length && selected[0]._id}`}
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      filename={!GridAttend && 'leave_requests'}
      downloadLoading={downloadLoading}
      both
    >
      {GridAttend && (
        <DashLayout
          leavesRecord={leaves}
          leaveThisWeek={leaveThisWeek}
          setApproveDialog={setApproveDialog}
          setRejectDialog={setRejectDialog}
          monthLeave={monthLeave}
          leave={leave}
          approveDialog={approveDialog}
          handleApproveClose={handleApproveClose}
          approveLeaveRequest={approveLeaveRequest}
          rejectDialog={rejectDialog}
          handleRejectClose={handleRejectClose}
          setLeave={setLeave}
          loading={dashLoading}
          leaves={leaveDashBoard}
          companyAdmin={companyAdmin}
        />
      )}
      {TableAttend && (
        <div>
          <CustomFilterModal
            open={openFilterModal}
            setOpen={setOpenFilterModal}
            data={modalOpen === 'position' ? positions : false}
            fieldValue="_id"
            fieldName={modalOpen === 'position' ? 'positionName' : 'name'}
            handleFilter={(filterData) => setFilterParams({ ...filterParams, [modalOpen]: filterData })}
            filterParams={filterParams[modalOpen]}
          />
          <CustomTable>
            <CustomTableHeading
              filterParams={filterParams}
              setFilterParams={setFilterParams}
              filterIcons={{
                POSITION: <FilterIcon onClick={headingOnClick.POSITION} value={filterParams.position} />,
              }}
              headingStyles={{
                NAME: { textAlign: 'left', paddingLeft: '10px' },
              }}
              heading={[
                <Checkbox
                  indeterminate={selected.length > 0 && selected.length < leaves.length}
                  checked={leaves.length > 0 && selected.length === leaves.length}
                  onClick={(event) => handleSelectAllClick(event, leaves, setSelected)}
                />,
                'NAME',
                'POSITION',
                'LEAVE TYPE',
                'FROM',
                'TO',
                'TOTAL DAYS',
                'TYPE',
                'ACTION TAKEN BY',
                companyAdmin ? 'ACTION' : 'Status',
              ]}
            />
            <TableBody>
              {!loading &&
                leaves.length > 0 &&
                leaves.map((item, index) => {
                  const isItemSelected = isSelected(item, selected)

                  return (
                    <CustomTableRow key={index} onClick={() => setLeave(item)}>
                      <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                        <Checkbox checked={isItemSelected} />
                      </TableCell>
                      <TableCell>
                        {' '}
                        <User image={item.employeeId && item.employeeId.profilePicture} label={item.employeeId && item.employeeId.firstName} />
                      </TableCell>
                      <TableCell>{item.employeeId && item.employeeId.position && item.employeeId.position.positionName}</TableCell>

                      <TableCell>{item.subType}</TableCell>
                      <TableCell>{formatDate(item.leaveFrom)}</TableCell>
                      <TableCell>{formatDate(item.leaveTo)}</TableCell>
                      <TableCell>{item.subType !== 'FULL DAY' ? '0.5 Day' : `${calculateTotalDays(item.leaveFrom, item.leaveTo)}`}</TableCell>
                      <TableCell>{item.leaveType && item.leaveType.name}</TableCell>
                      <TableCell>{item.approveAdmin ? item.approveAdmin.firstName : '----'}</TableCell>
                      {<TableCell>{fetchStatus(item.leaveApproved)}</TableCell>}
                      {/* <TableCell>
                  <IconButton color="inherit" onClick={() => setOpen(true)}>
                    <HiOutlineInformationCircle />
                  </IconButton>
                </TableCell> */}
                    </CustomTableRow>
                  )
                })}
            </TableBody>
          </CustomTable>
          <ConfirmDialog
            open={deleteDialog}
            handleClose={() => setDeleteDialog(false)}
            name={selected.length === 1 && selected[0].name}
            handleSubmit={() => deleteLeave({ leaveId: selected[0]._id }, setSelected)}
          />

          <ConfirmDialog
            open={multipleDeleteDialog}
            handleClose={() => setMultipleDeleteDialog(false)}
            name={selected.length === 1 && selected[0].name}
            handleSubmit={() => deleteManyLeave({ leaveId: multipleId }, setSelected)}
          />

          {!loading && !leaves.length && <NoDataFound />}
          {loading && <Loader />}

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: loading ? '50px' : '0' }}>
            {!loading && Boolean(leaves.length) && <CustomPagination noOfPages={noOfPages} page={filterParams.page} handleChange={handleChange} />}
          </div>
          {/* {leave ? <OverviewDialog open={open} handleClose={handleClose} details={details} /> : null} */}
          {leave ? (
            <ApproveDialog
              open={approveDialog}
              handleClose={handleApproveClose}
              name={leave.employeeId && leave.employeeId.firstName}
              approve
              handleSubmit={approveLeaveRequest}
              adminReason={adminReason}
              setAdminReason={setAdminReason}
            />
          ) : null}
          {leave ? (
            <ApproveDialog
              open={rejectDialog}
              handleClose={handleRejectClose}
              name={leave.employeeId && leave.employeeId.firstName}
              handleSubmit={approveLeaveRequest}
              adminReason={adminReason}
              setAdminReason={setAdminReason}
            />
          ) : null}
        </div>
      )}
    </Layout>
  )
}
